import { createContext } from 'react'
import { BreadCrumbState } from 'app/crumbs/context/BreadCrumbDataProviderContainer'

export interface BreadCrumbContext {
  breadCrumbData: BreadCrumbState

  setBreadCrumbData(data: BreadCrumbState): void
}

export const BreadCrumbDataContext = createContext<BreadCrumbContext>({ breadCrumbData: {}, setBreadCrumbData: () => {} })

const { Consumer, Provider } = BreadCrumbDataContext
export const BreadCrumbDataConsumer = Consumer
export const BreadCrumbDataProvider = Provider
